import {useCallback} from 'react';

import {OnboardingTipTypesEnum} from '../../models/api/preferencesModel';
import {useInfoBubblesContext} from '../common/infoBubbles/infoBubblesContext';

/*
 * Hook.
 */

interface InfoBubblePresenter {
  isVisible: boolean;
  closeInfoBubble: (types?: ReadonlyArray<OnboardingTipTypesEnum>) => void;
  openInfoBubble: (arg: OnboardingTipTypesEnum) => void;
}

export function useOnboardingInfoBubblePresenter(type: OnboardingTipTypesEnum): InfoBubblePresenter {
  const context = useInfoBubblesContext();
  const {infoBubbles, closeInfoBubbles: close, openInfoBubble: open} = context;
  const isVisible = infoBubbles[type] || false;

  const closeInfoBubble = useCallback(
    (types?: ReadonlyArray<OnboardingTipTypesEnum>) => {
      // By default, close info bubble of identical type
      if (!types) {
        close(type);
        return;
      }

      close(...types);
    },
    [close, type],
  );

  const openInfoBubble = useCallback(
    (infoType: OnboardingTipTypesEnum) => {
      open(infoType);
    },
    [open],
  );

  return {
    isVisible,
    closeInfoBubble,
    openInfoBubble,
  };
}
